/* Bannière cookies Puure : snippets/cookie-consent.liquid */
(function () {
  var KEY = 'puure_cc_v1';
  // UE/EEE + Royaume-Uni + Suisse : zones où le consentement est demandé. Ailleurs (AU, US…) : pas de bannière.
  var CONSENT_COUNTRIES = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE IS LI NO GB CH'.split(' ');

  // Signal pour les pop-ups (water report, spin-to-win, A/B) : résolu quand il n'y a pas de bannière
  // ou quand le visiteur a fait son choix. Les pop-ups attendent ce signal avant de s'ouvrir.
  var releaseGate;
  window.puureCookieGate = new Promise(function (resolve) { releaseGate = resolve; });

  var root = document.getElementById('cookie-consent');
  if (!root || !window.Shopify || !window.Shopify.loadFeatures) { releaseGate(); return; }

  var steps = root.querySelectorAll('[data-step]');
  var preview = /[?&]cookies_preview=1/.test(location.search);

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function remember(v) { try { localStorage.setItem(KEY, v + '|' + Date.now()); } catch (e) {} }
  function cp() { return window.Shopify.customerPrivacy; }

  function goTo(name) {
    steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
  }
  function show(step) {
    var consent = cp() && cp().currentVisitorConsent ? cp().currentVisitorConsent() : {};
    root.querySelector('[data-cc-cat="analytics"]').checked = consent.analytics === 'yes';
    root.querySelector('[data-cc-cat="marketing"]').checked = consent.marketing === 'yes';
    goTo(step || 'intro');
    root.hidden = false;
    document.documentElement.classList.add('cookie-consent-open');
  }
  function hide() {
    root.hidden = true;
    document.documentElement.classList.remove('cookie-consent-open');
  }

  function decide(analytics, marketing, label) {
    remember(label);
    hide();
    releaseGate();
    if (!cp()) return;
    cp().setTrackingConsent({
      analytics: analytics,
      preferences: analytics,
      marketing: marketing,
      sale_of_data: marketing,
      metafields: [{ key: 'user_interaction', value: 'true' }] // vrai choix du client (même logique que Respire)
    }, function () {
      document.dispatchEvent(new CustomEvent('puure:cookie-consent', { detail: { choice: label } }));
    });
  }

  function inZone(code) { return CONSENT_COUNTRIES.indexOf(String(code || '').slice(0, 2).toUpperCase()) !== -1; }

  // Pays du visiteur : géoloc IP de Shopify (getRegion() peut être périmé, ex. « ID » vu pour un visiteur en France).
  function visitorCountry() {
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && d.detected_values && d.detected_values.country && d.detected_values.country.handle; })
      .catch(function () { return null; });
  }

  // Résout true si la bannière doit s'afficher.
  function needsBanner() {
    if (preview) return Promise.resolve(true);
    if (document.getElementById('shopify-pc__banner')) return Promise.resolve(false); // bannière native Shopify encore active : on ne double pas
    if (stored()) return Promise.resolve(false);
    var c = cp();
    if (!c) return Promise.resolve(false);
    // On ne se fie qu'à un vrai clic sur notre bannière (metafield ou stockage local) : un « yes » par défaut
    // de Shopify (bannière native supprimée, zone sans règle) ne doit pas masquer la bannière.
    if (c.getTrackingConsentMetafield && c.getTrackingConsentMetafield('user_interaction') === 'true') return Promise.resolve(false);
    if (c.shouldShowBanner && c.shouldShowBanner()) return Promise.resolve(true);
    return visitorCountry().then(function (country) {
      return country ? inZone(country) : inZone(c.getRegion ? c.getRegion() : '');
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc]');
    if (!btn) return;
    var action = btn.getAttribute('data-cc');
    if (action === 'accept') decide(true, true, 'accept');
    else if (action === 'choose') goTo('choose');
    else if (action === 'save') {
      var a = root.querySelector('[data-cc-cat="analytics"]').checked;
      var m = root.querySelector('[data-cc-cat="marketing"]').checked;
      decide(a, m, a && m ? 'accept' : (a || m ? 'partial' : 'decline'));
    }
  });

  // Réouverture depuis n'importe quel lien vers #cookies (ex. lien « Cookies » du footer).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href$="#cookies"]');
    if (!link) return;
    e.preventDefault();
    show('choose');
  });

  window.Shopify.loadFeatures([{
    name: 'consent-tracking-api',
    version: '0.1',
    onLoad: function () { needsBanner().then(function (yes) { if (yes) show(); else releaseGate(); }); }
  }]);
})();
